import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ContentType } from "../shared/contentTypes";
import { FeedbackDataModel, FeedbackSyncDataModel, AddFeedbackModel } from "../shared/models/feedback.model";
import { CoreLogService } from "./log.service";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { IObjectObserver } from "./IObjectObserver";
import { ObjectObserverFactory } from "./objectObserverFactory";

@Injectable({
  providedIn: "root"
})
export class FeedbackService {

  // Momentan ist noch nicht das speichern von Feedback eingebaut
  // private _feedbackObsServ: IObjectObserver<FeedbackDataModel>;

  constructor(private _coreLogService: CoreLogService,
    private _objObsInjectHelper: CircularInjectionHelper) {
    const me = this;
    // me._feedbackObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<FeedbackDataModel>(ContentType.Feedback, me._objObsInjectHelper);
  }

  // public get ObserveChanges(): Observable<(string | number)[]> {
  //   return this._feedbackObsServ.ObserveChanges;
  // }

  public AddFeedback(message: string, rating: number): Promise<void> {
    const me = this;
    return new Promise<void>((resolve, reject) => {
      try {
        if (me._objObsInjectHelper.coreCOMService.environment.networkInformation.isOnline) {
          me.SendFeedbackToServer(message, rating)
            .then((SyncDataModel) => {
              resolve();
              // vorab speichern, so wird etwas zeit eingesparrt
              // me._feedbackObsServ.SetObjects(SyncDataModel.feedback)
              //   .then(resolve)
              //   .catch((error) => {
              //     me._coreLogService.error("FeedbackService.AddFeedback", "SetObjects", error);
              //     reject();
              //   });
            })
            .catch((error) => { me._coreLogService.error("FeedbackService.AddFeedback", "RequestService", error); reject(); });
        } else {
          me._coreLogService.error("FeedbackService.AddFeedback", "no hasInternet");
          reject();
        }
      } catch (error) {
        me._coreLogService.error("FeedbackService.AddFeedback", "try catch", error);
        reject();
      }
    });
  }

  private SendFeedbackToServer(message: string, rating: number): Promise<FeedbackSyncDataModel> {
    const me = this;
    return new Promise<FeedbackSyncDataModel>((resolve, reject) => {
      try {
        const RequestData = new AddFeedbackModel();
        RequestData.message = message;
        RequestData.rating = rating;
        const FunctionName = "feedback/AddFeedback";
        const SyncDataModelConstructor = FeedbackSyncDataModel;
        me._objObsInjectHelper.yourAppServer.Api.RequestService(SyncDataModelConstructor, FunctionName, RequestData)
          .then((response) => {
            if (response.OK) {
              me._coreLogService.debug("FeedbackService.SendFeedbackToServer", "RequestService (response OK)", response);
              resolve(response.Data);
            } else {
              me._coreLogService.error("FeedbackService.SendFeedbackToServer", "RequestService (response not OK)", response);
              reject(response.HttpResponse.codeText);
            }
          })
          .catch((error) => { me._coreLogService.error("FeedbackService.SendFeedbackToServer", "RequestService", error); reject(); });
      } catch (error) {
        me._coreLogService.error("FeedbackService.SendFeedbackToServer", "try catch", error);
        reject();
      }
    });
  }

}
